export default __webpack_public_path__ + "static/Simplified_Laws_of_the_Game_Desktop-fcd9dd407bf707a9ced8fe872c4b174e.svg";